import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import FeaturedGrid from './components/FeaturedGrid';
import ArticlesGrid from './components/ArticlesGrid';
import ReviewSection from './components/ReviewSection';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://kakobuyspreadsheet.wtf';

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const websiteJson = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'Kakobuy Spreadsheet Polska',
    url: siteUrl,
    description: 'Najlepszy Kakobuy Spreadsheet Polska 2026. Odkryj aktualne listy produktów, przewodniki, porównania oraz najlepszy Kakobuy Spreadsheet dla polskich użytkowników.',
    inLanguage: 'pl-PL',
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <CategorySection />
        <FeaturedGrid />
        <ArticlesGrid />
        <ReviewSection />
        <CTASection />
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: websiteJson }}
      />
    </div>
  );
}